// extracted by mini-css-extract-plugin
export default {"photos":"Users_photos__ZjkZZ","container":"Users_container__1bj7q","gridContainer":"Users_gridContainer__4w6t-","card":"Users_card__g+Jm8"};